import React from 'react';
import classNames from 'classnames';
import styles from './index.module.scss';
import { MarkOrderConfig } from '../../types';

interface IProps {
  order: number;
  markOrderConfig?: MarkOrderConfig;
}

function MarkOrder({
  order, markOrderConfig,
}: IProps) {
  return (
    <div className={classNames(styles['mark-order'], markOrderConfig?.className)}>
      <svg className={styles.markOrderBgIcon} viewBox="5 1 26 28" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_d_25734_23003)">
          <path d="M18 4.5C23.799 4.5 28.5 9.20101 28.5 15C28.5 20.799 23.799 25.5 18 25.5H9.25925C9.11447 25.5 8.95474 25.5007 8.8175 25.4895C8.67023 25.4774 8.47555 25.4476 8.27487 25.3454C8.00789 25.2093 7.79068 24.9921 7.65465 24.7251C7.55242 24.5244 7.52257 24.3298 7.51054 24.1825C7.49933 24.0453 7.50001 23.8855 7.50001 23.7408V15C7.50001 9.20101 12.201 4.50001 18 4.5Z" shapeRendering="crispEdges" />
          <path d="M18.5791 3.76465C24.5232 4.06605 29.25 8.98102 29.25 15C29.25 21.2132 24.2132 26.25 18 26.25H9.25879C9.12539 26.25 8.93111 26.2515 8.75684 26.2373C8.56266 26.2214 8.25822 26.1785 7.93457 26.0137C7.52649 25.8057 7.19427 25.4735 6.98633 25.0654C6.82149 24.7418 6.77856 24.4373 6.7627 24.2432C6.74849 24.0689 6.75 23.8746 6.75 23.7412V15C6.75 8.7868 11.7868 3.75001 18 3.75L18.5791 3.76465Z" strokeOpacity="0.8" strokeWidth="1.5" strokeLinejoin="round" shapeRendering="crispEdges" />
        </g>
        <defs>
          <filter id="filter0_d_25734_23003" x="0" y="0" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
            <feOffset dy="3" />
            <feGaussianBlur stdDeviation="3" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_25734_23003" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_25734_23003" result="shape" />
          </filter>
        </defs>
      </svg>
      <span className="inlineMarkOrder">
        {order}
      </span>
    </div>
  );
}

export default MarkOrder;
